import { Clock } from "lucide-react";

const ComingSoonCard = () => (
  <div className="relative rounded-xl flex flex-col justify-around border border-orange-200 shadow-sm bg-gradient-to-br from-orange-50 to-orange-100 overflow-hidden">
    <div className="absolute -top-6 -right-6 w-24 h-24 bg-orange-300/30 rounded-full blur-xl"></div>
    <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-orange-400/20 rounded-full blur-xl"></div>

    <div className="relative z-10 flex flex-col items-center justify-center h-48 sm:h-52 p-4 text-center">
      <div className="bg-white/90 shadow px-4 py-1 rounded-full text-xs font-semibold text-orange-600 border border-orange-200 mb-3">
        Coming Soon
      </div>

      <Clock className="w-10 h-10 text-orange-600 mb-3 animate-pulse" />

      <h3 className="text-orange-700 font-semibold text-lg tracking-wide">
        New Listings Incoming
      </h3>

      <p className="text-orange-600 text-sm mt-1 opacity-80">
        Stay tuned for fresh properties
      </p>
    </div>
  </div>
);

export default ComingSoonCard